import React, { useEffect, useState } from 'react';
// bootstrap
import { Button, Carousel } from 'react-bootstrap';
// Services
import ActiveService from '../../../services/active';
import { CODES } from '../../../utils/responseCodes';
// Components
import Loader from '../../components/Spinner/Loader';
import MainInput from '../../components/general/MainInput';
import DynamicTitle from '../../../utils/DynamicTitle';
import { getDateOL } from '../../../utils/function';
import BodyEquipementView from '../../components/EquipementRegister/BodyEquipementView';
import GeneralService from '../../../services/general';
import MainSelect from '../../components/general/MainSelect';
import MainSelectPlus from '../../components/general/MainSelectPlus';
const EquipmentView = () => {
    const now = new Date();
    const [openLoader, setOpenLoader] = useState(false);
    const [messageLoader, setMessageLoader] = useState(null);

    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const [dateStart, setDateStart] = useState(getDateOL(firstDayOfMonth, 'short'));
    const [dateEnd, setDateEnd] = useState(getDateOL(lastDayOfMonth, 'short'));

    const [equipoRecibido, setEquipoRecibido] = useState([]);
    console.log("🚀 ~ EquipmentView ~ equipoRecibido:", equipoRecibido)
    const [filteredEquipo, setFilteredEquipo] = useState([]);
   

    const [tipoEquipo, setTipoEquipo] = useState(null);
    const [estadoEquipo, setEstadoEquipo] = useState(null);
    const [jefes, setJefes] = useState(null);
    // Filtros
    const [trabajador, setTrabajador] = useState('');
    const [desTipoEquipo, setDesTipoEquipo] = useState('');
    const [desEstado, setDesEstado] = useState('');
    const [desJefe, setDesJefe] = useState('');
  
    
    useEffect(() => {
        init();
        getEquipoRecibido();
        getTipoEquipoFull();
        getEstadoEquipo();
        getAreaOrganigrama();
    }, []);

    useEffect(() => {
        filtrarEquipos();
    }, [equipoRecibido, trabajador, desTipoEquipo, desEstado, dateStart, dateEnd,desJefe]);

    const init = async () => {
        // Inicialización si necesitas
    };

    const getEquipoRecibido = async () => {
        try {
            setOpenLoader(true);
            setMessageLoader('Buscando registros ...');
            const result = await ActiveService.getEquipoRecibido();
            if (result.status === CODES.SUCCESS_200) {
                setEquipoRecibido(result.data || []);
            }
        } catch (error) {
            console.error(`Error en getEquipoRecibido: ${error}`);
        } finally {
            setOpenLoader(false);
            setMessageLoader(null);
        }
    };

    const filtrarEquipos = () => {
        const inicio = new Date(dateStart);
        const fin = new Date(dateEnd);
        fin.setHours(23, 59, 59, 999);
    
        const filtrados = equipoRecibido.filter(item => {
            const fechaIngreso = new Date(item.fechaIngreso);
    
            const matchesFecha = fechaIngreso >= inicio && fechaIngreso <= fin;
            const matchesTrabajador = item.trabajador?.toLowerCase().includes(trabajador.toLowerCase());
            const matchesTipo = desTipoEquipo === '' || desTipoEquipo === '0' || item.desTipoEquipo?.toLowerCase().includes(desTipoEquipo.toLowerCase());
            const matchesEstado = desEstado === '' || desEstado === '0' || item.desEstado?.toLowerCase().includes(desEstado.toLowerCase());
            const matchesJefe = desJefe === '' ||  desJefe === '0' || item.desJefe?.toLowerCase().includes(desJefe.toLowerCase());
    
            return matchesFecha && matchesTrabajador && matchesTipo && matchesEstado && matchesJefe;
        });
    
        setFilteredEquipo(filtrados);
    };
    

    const getTipoEquipoFull = async () => {
        try {
            const result = await GeneralService.getTipoEquipoFull();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_tipoEquipo;
                    element.value = element.id_tipoEquipo;
                    element.label = element.desTipoEquipo;
                    element.codigoBarras = element.codigoBarras;
                });
                setTipoEquipo(result.data);
            }
        } catch (error) {
            console.error(`Error en getTipoEquipoFull: ${error}`);
        }
    };

    const getEstadoEquipo = async () => {
        try {
            const result = await GeneralService.getEstadoEquipo();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_estadoEquipo;
                    element.value = element.id_estadoEquipo;
                    element.label = element.desEstado;
                });
                setEstadoEquipo(result.data);
            }
        } catch (error) {
            console.error(`Error en getEstadoEquipo: ${error}`);
        }
    };

    const getAreaOrganigrama = async () => {
        try {
            const result = await GeneralService.getAreaOrganigrama();
            if (result.status === CODES.SUCCESS_200) {
                result.data.forEach(element => {
                    element.id = element.id_areaOrg;
                    element.value = element.id_areaOrg;
                    element.label = element.Jefe;
                    element.CodJefe = element.CodJefe;
                });
                setJefes(result.data);
            }
        } catch (error) {
            console.error(`Error en getAreaOrganigrama: ${error}`);
        }
    };

    const exportActivosRegistrados = async (filteredEquipo) => {
        try {
            setOpenLoader(true);
            setMessageLoader('Generando Reporte ...');
            const result = await ActiveService.exportActivosRegistrados(filteredEquipo);

            if (result.status === 200) {
                const blob = new Blob([result.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const downloadUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = 'reporte_activos.xlsx';
                link.click();
                URL.revokeObjectURL(downloadUrl);
            }
            getEquipoRecibido();
            setOpenLoader(false);
        } catch (error) {
            console.error('Error al exportar activos:', error);
            setOpenLoader(false);
        }
    };
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <DynamicTitle title="Ver Equipos registrados" />
            <div className="card" style={{ width: '95%', margin: "1rem", padding: "0.5rem" }}>
                <div className="card-body">
                    <div className="row" style={{ marginBottom: '1rem', alignItems: 'flex-end' }}>
                        <div className="col-md-1">
                            <MainInput
                                title="Fecha Inicio"
                                name="fechaInicio"
                                type="date"
                                value={dateStart}
                                onChange={(e) => setDateStart(e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-md-1">
                            <MainInput
                                title="Fecha Fin"
                                name="fechaFin"
                                type="date"
                                value={dateEnd}
                                onChange={(e) => setDateEnd(e.target.value)}
                                required
                            />
                        </div>

                        <div className="col-md-3">
                            <MainInput
                                title="Trabajador"
                                name="trabajador"
                                type="text"
                                value={trabajador}
                                onChange={(e) => setTrabajador(e.target.value)}
                            />
                        </div>

                        <div className="col-md-2">
                            <MainSelectPlus
                                title="Jefe"
                                name="desJefe"
                                value={desJefe || null}
                                options={[
                                    { id: '0', label: 'Seleccione una opción' }, // 👈 Opción default manual
                                    ...jefes?.map(jefe => ({
                                        id: jefe.label,
                                        label: jefe.label
                                    })) || []
                                ]}
                                onChange={(e) => setDesJefe(e.target.value)} // 👈 este es el formato esperado
                                isClearable={true}
                            />
                        </div>

                        <div className="col-md-2">
                            <MainSelectPlus
                                title="Tipo Equipo"
                                name="tipoEquipo"
                                value={desTipoEquipo}
                                options={[
                                    { id: '0', label: 'Seleccione una opción' }, // 👈 Opción default manual
                                    ...tipoEquipo?.map(tipo => ({
                                        id: tipo.label,
                                        label: tipo.label
                                    })) || []
                                ]}
                                onChange={(e) => setDesTipoEquipo(e.target.value)}
                                isClearable={true} // Opcional: para que puedan limpiar el select
                            />
                        </div>

                        <div className="col-md-2">
                            <MainSelectPlus
                                title="Estado"
                                name="estadoEquipo"
                                value={desEstado}
                                options={[
                                    { id: '0', label: 'Seleccione una opción' }, // 👈 Opción default manual
                                    ...estadoEquipo?.map(estado => ({
                                        id: estado.label,
                                        label: estado.label
                                    })) || []
                                ]}
                                onChange={(e) => setDesEstado(e.target.value)}
                                isClearable={true}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-3">
                        <button
                            type="button"
                            className="btn btn-success btn-sm"
                            title="Exportar"
                            onClick={() => exportActivosRegistrados(filteredEquipo)}
                        >
                            Exportar
                        </button>
                    </div>
                    <BodyEquipementView equipoRecibido={filteredEquipo} />
                </div>
            </div>

            <Loader open={openLoader} message={messageLoader} />
        </div>
    );
};

export default EquipmentView;
